module.exports = __webpack_public_path__ + "img/endofuse.f7eacbd9.png";